import connect from 'components/Shared/connect';
import { ProductPageModel } from 'models/ProductPageModel';
import { getOthersAlsoBoughtProducts, getProductTitle } from '../../selector';
import { DetailedProduct } from 'models/DetailedProduct';
import { rm, NO_ELEMENT } from 'utils';
import { ProductListView } from '../../productListView';
import { ListViewProduct } from 'models/ListViewProduct';
import { ProductSection } from './sections/productSection';
import {
  getOthersAlsoBoughtListName,
  mapListViewProductToGtm
} from 'store/googleTagManager/events/utils';
import { GtmSelectItem, GtmViewListItem } from 'store/googleTagManager/actions';
import { useDispatch } from 'react-redux';
import { RelatedListViewProduct } from 'models/RelatedListViewProduct';

interface OwnProps {
  className?: string;
}
type MergedProps = OwnProps &
  Pick<ProductPageModel, 'othersAlsoBoughtProducts'> &
  Pick<DetailedProduct, 'title'>;

const showOthersAlsoBought = (products?: ListViewProduct[]): products is ListViewProduct[] =>
  products !== undefined && products.length > 0;

const _OthersAlsoBoughtProducts = ({ othersAlsoBoughtProducts, title }: MergedProps) => {
  const reduxDispatch = useDispatch();

  const createGtmProduct = (product: ListViewProduct) => {
    const index = othersAlsoBoughtProducts?.indexOf(product as RelatedListViewProduct) ?? 0;
    const listName = getOthersAlsoBoughtListName(product);
    return mapListViewProductToGtm({ product, indexInList: index, listName });
  };
  const handleProductClick = (product: ListViewProduct) => {
    reduxDispatch(GtmSelectItem({ gtmItemProduct: createGtmProduct(product) }));
  };

  const gtmOnViewItem = (products: ListViewProduct[]) => {
    const gtmItemProducts = products.map(product => createGtmProduct(product));

    reduxDispatch(GtmViewListItem({ gtmItemProducts }));
  };

  return showOthersAlsoBought(othersAlsoBoughtProducts) ? (
    <ProductSection title={rm('product_othersbought', title)}>
      <ProductListView
        onProductClick={handleProductClick}
        products={othersAlsoBoughtProducts}
        gtmOnViewItems={gtmOnViewItem}
      />
    </ProductSection>
  ) : (
    NO_ELEMENT
  );
};

export const OthersAlsoBoughtProducts = connect<MergedProps, OwnProps>(({ currentPage }) => ({
  othersAlsoBoughtProducts: getOthersAlsoBoughtProducts(currentPage),
  title: getProductTitle(currentPage)
}))(_OthersAlsoBoughtProducts);
